/** @format */

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum AttributeKey {
    UNDEFINED_REASON = 'UNDEFINED_REASON',
    SHUTTER_COUNT = 'SHUTTER_COUNT',
    BATTERY_CHARGE_COUNT = 'BATTERY_CHARGE_COUNT',
    FIRMWARE = 'FIRMWARE',
    HOUR_COUNT = 'HOUR_COUNT',
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
export interface Attribute {
    id: string;
    key: AttributeKey;
    content: string;
    value: number;
}
